import { render, staticRenderFns } from "./DialogHelp.vue?vue&type=template&id=061aeee2"
import script from "./DialogHelp.vue?vue&type=script&lang=js"
export * from "./DialogHelp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports